export default [
  {
    component: 'CNavItem',
    name: 'Dashboard Inventory',
    to: '/dashboard-inventory',
    icon: 'cil-chart-pie',
  },
  {
    component: 'CNavItem',
    name: 'Dashboard Kepegawaian',
    to: '/dashboard-kepegawaian',
    icon: 'cil-people',
  },
  {
    component: 'CNavItem',
    name: 'Dashboard Keuangan',
    to: '/dashboard-keuangan',
    icon: 'cil-money',
  },
  {
    component: 'CNavItem',
    name: 'Dashboard Publik',
    to: '/dashboard-publik',
    icon: 'cil-share',
  },
  {
    component: 'CNavItem',
    name: 'Dashboard Distribusi',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    component: 'CNavTitle',
    name: 'Master',
  },
  {
    component: 'CNavItem',
    name: 'Cabang',
    to: '/cabang',
    icon: 'cil-notes',
  },
  {
    component: 'CNavItem',
    name: 'Gudang',
    to: '/gudang',
    icon: 'cil-home',
  },
  {
    component: 'CNavItem',
    name: 'Lokasi Gudang',
    to: '/lokasi',
    icon: 'cil-location-pin',
  },
  {
    component: 'CNavItem',
    name: 'User',
    to: '/user',
    icon: 'cil-user',
  },
  {
    component: 'CNavItem',
    name: 'Pelanggan',
    to: '/pelanggan',
    icon: 'cil-star',
  },
  {
    component: 'CNavItem',
    name: 'Mitra',
    to: '/mitra',
    icon: 'cil-user',
  },
  {
    component: 'CNavItem',
    name: 'Produk',
    to: '/produk',
    icon: 'cil-basket',
  },
  {
    component: 'CNavItem',
    name: 'Perusahaan',
    to: '/perusahaan',
    icon: 'cil-home',
  },
  {
    component: 'CNavItem',
    name: 'Pengaturan Perusahaan',
    to: '/pengaturan-perusahaan',
    icon: 'cil-settings',
  },
  {
    component: 'CNavItem',
    name: 'Logo & Branding',
    to: '/pengaturan-aplikasi',
    icon: 'cil-star',
  },
  {
    component: 'CNavItem',
    name: 'Pengaturan Menu',
    to: '/pengaturan-menu',
    icon: 'cil-settings',
  },
  {
    component: 'CNavTitle',
    name: 'Pergudangan',
  },
  {
    component: 'CNavItem',
    name: 'Order Barang',
    to: '/order-barang',
    icon: 'cil-file',
  },
  {
    component: 'CNavItem',
    name: 'Pergerakan Stok',
    to: '/pergerakan-stok',
    icon: 'cil-file',
  },
  {
    component: 'CNavItem',
    name: 'Audit Stok',
    to: '/audit-stok',
    icon: 'cil-file',
  },
  {
    component: 'CNavItem',
    name: 'Import Saldo Awal',
    to: '/import-saldo-awal',
    icon: 'cil-cloud-upload',
  },
  {
    component: 'CNavTitle',
    name: 'Penjualan',
  },
  {
    component: 'CNavItem',
    name: 'Sales Order',
    to: '/penjualan/order',
    icon: 'cil-cart',
  },
  {
    component: 'CNavItem',
    name: 'Faktur Penjualan',
    to: '/penjualan/faktur',
    icon: 'cil-description',
  },
  {
    component: 'CNavItem',
    name: 'Piutang',
    to: '/penjualan/piutang',
    icon: 'cil-wallet',
  },
  {
    component: 'CNavItem',
    name: 'Kwitansi',
    to: '/penjualan/kwitansi',
    icon: 'cil-dollar',
  },
  {
    component: 'CNavTitle',
    name: 'Pembelian',
  },
  {
    component: 'CNavItem',
    name: 'Purchase Order',
    to: '/pembelian/order',
    icon: 'cil-inbox',
  },
  {
    component: 'CNavItem',
    name: 'Faktur Pembelian',
    to: '/pembelian/faktur',
    icon: 'cil-notes',
  },
  {
    component: 'CNavItem',
    name: 'Hutang',
    to: '/pembelian/hutang',
    icon: 'cil-money',
  },
  {
    component: 'CNavTitle',
    name: 'Pajak',
  },
  {
    component: 'CNavItem',
    name: 'Monitoring Faktur',
    to: '/pajak/monitoring',
    icon: 'cil-task',
  },
  {
    component: 'CNavItem',
    name: 'Pencocokan Faktur',
    to: '/pajak/pencocokan',
    icon: 'cil-check-circle',
  },
  {
    component: 'CNavItem',
    name: 'Pengaturan Pajak',
    to: '/pajak/pengaturan',
    icon: 'cil-settings',
  },
  {
    component: 'CNavTitle',
    name: 'Coffee Shop',
  },
  {
    component: 'CNavItem',
    name: 'Kasir Kafe',
    to: '/kafe/kasir',
    icon: 'cil-cart',
  },
  {
    component: 'CNavItem',
    name: 'Dashboard Kafe',
    to: '/kafe/dashboard',
    icon: 'cil-chart-pie',
  },
  {
    component: 'CNavItem',
    name: 'Menu & Resep',
    to: '/kafe/menu',
    icon: 'cil-list',
  },
  {
    component: 'CNavItem',
    name: 'Bahan Baku',
    to: '/kafe/bahan',
    icon: 'cil-inbox',
  },
  {
    component: 'CNavItem',
    name: 'HPP & Harga Jual',
    to: '/kafe/hpp',
    icon: 'cil-calculator',
  },
  {
    component: 'CNavItem',
    name: 'Stok Bahan',
    to: '/kafe/stok',
    icon: 'cil-layers',
  },
  {
    component: 'CNavItem',
    name: 'Pembelian Bahan',
    to: '/kafe/pembelian',
    icon: 'cil-cart',
  },
  {
    component: 'CNavItem',
    name: 'Keuangan Kafe',
    to: '/kafe/keuangan',
    icon: 'cil-wallet',
  },
  {
    component: 'CNavItem',
    name: 'Pengaturan Kafe',
    to: '/kafe/pengaturan',
    icon: 'cil-settings',
  },
  {
    component: 'CNavTitle',
    name: 'POS UMKM',
  },
  {
    component: 'CNavItem',
    name: 'Kasir POS',
    to: '/pos/kasir',
    icon: 'cil-cart',
  },
  {
    component: 'CNavItem',
    name: 'Riwayat Penjualan',
    to: '/pos/riwayat',
    icon: 'cil-list',
  },
  {
    component: 'CNavItem',
    name: 'Kasbon',
    to: '/pos/kasbon',
    icon: 'cil-wallet',
  },
  {
    component: 'CNavItem',
    name: 'Barang & Stok',
    to: '/pos/barang',
    icon: 'cil-storage',
  },
  {
    component: 'CNavItem',
    name: 'Pengeluaran',
    to: '/pos/pengeluaran',
    icon: 'cil-money',
  },
  {
    component: 'CNavItem',
    name: 'Laporan',
    to: '/pos/laporan',
    icon: 'cil-chart-pie',
  },
  {
    component: 'CNavItem',
    name: 'Info Toko',
    to: '/pos/toko',
    icon: 'cil-home',
  },
  {
    component: 'CNavTitle',
    name: 'Sewa Gudang',
  },
  {
    component: 'CNavItem',
    name: 'Kontrak Sewa',
    to: '/sewa/kontrak',
    icon: 'cil-file',
  },
  {
    component: 'CNavItem',
    name: 'Invoice Sewa',
    to: '/sewa/invoice',
    icon: 'cil-file',
  },
  {
    component: 'CNavTitle',
    name: 'Transaksi',
  },
  {
    component: 'CNavItem',
    name: 'Upload',
    to: '/upload',
    icon: 'cil-file',
  },
  {
    component: 'CNavItem',
    name: 'Pengiriman',
    to: '/pengiriman',
    icon: 'cil-calculator',
  },
  {
    component: 'CNavItem',
    name: 'Update Pengiriman',
    to: '/updatepengiriman',
    icon: 'cil-pencil',
  },
  {
    component: 'CNavItem',
    name: 'Report',
    to: '/report',
    icon: 'cil-notes',
  },
  {
    component: 'CNavTitle',
    name: 'Laporan Pergudangan',
  },
  {
    component: 'CNavItem',
    name: 'Laporan Stok Barang',
    to: '/laporan/stok-barang',
    icon: 'cil-list',
  },
  {
    component: 'CNavItem',
    name: 'Laporan Mutasi Stok',
    to: '/laporan/mutasi-stok',
    icon: 'cil-transfer',
  },
  {
    component: 'CNavItem',
    name: 'Laporan Order Barang',
    to: '/laporan/order-barang',
    icon: 'cil-file',
  },
  {
    component: 'CNavItem',
    name: 'Laporan Audit Stok',
    to: '/laporan/audit-stok',
    icon: 'cil-check-circle',
  },
  {
    component: 'CNavTitle',
    name: 'Kepegawaian',
  },
  {
    component: 'CNavItem',
    name: 'Data Karyawan',
    to: '/kepegawaian/karyawan',
    icon: 'cil-people',
  },
  {
    component: 'CNavItem',
    name: 'Jam Kerja',
    to: '/kepegawaian/jam-kerja',
    icon: 'cil-clock',
  },
  {
    component: 'CNavItem',
    name: 'Lokasi Presensi',
    to: '/kepegawaian/lokasi-presensi',
    icon: 'cil-location-pin',
  },
  {
    component: 'CNavItem',
    name: 'Device Presensi',
    to: '/kepegawaian/perangkat-presensi',
    icon: 'cil-lock-locked',
  },
  {
    component: 'CNavItem',
    name: 'Upload Payslip',
    to: '/kepegawaian/upload-payslip',
    icon: 'cil-cloud-upload',
  },
  {
    component: 'CNavItem',
    name: 'Payslip',
    to: '/kepegawaian/payslip',
    icon: 'cil-description',
  },
  {
    component: 'CNavItem',
    name: 'Rekap Presensi',
    to: '/kepegawaian/rekap-presensi',
    icon: 'cil-calendar-check',
  },
  {
    component: 'CNavItem',
    name: 'Persetujuan ESS',
    to: '/kepegawaian/persetujuan',
    icon: 'cil-task',
  },
  {
    component: 'CNavTitle',
    name: 'Kartu Nama',
  },
  {
    component: 'CNavItem',
    name: 'Kartu Nama Digital',
    to: '/kartu-nama/daftar',
    icon: 'cil-contact',
  },
  {
    component: 'CNavItem',
    name: 'Desain Kartu',
    to: '/kartu-nama/desain',
    icon: 'cil-color-palette',
  },
  {
    component: 'CNavTitle',
    name: 'Pemilihan',
  },
  {
    component: 'CNavItem',
    name: 'Pemilihan',
    to: '/pemilihan/panitia',
    icon: 'cil-check-circle',
    modul: 'pemilihan',
  },
]
